"use client";

import { forwardRef, type ReactNode } from "react";
import TrustIndexCircle from "./TrustIndexCircle";

export interface TrustIndexCircleData {
  segments: Array<{ value: number; label?: string }>;
  totalValue?: number;
  totalLabel: string;
  title: string;
  hasTrustScore: boolean;
  showSparkle?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
}

interface TrustIndexLayoutProps {
  riskCard: ReactNode;
  children: ReactNode;
  circle: TrustIndexCircleData;
  circleSlot?: ReactNode;
  videoLoaderMode?: boolean;
  blurClass?: string;
}

const TrustIndexLayout = forwardRef<HTMLDivElement, TrustIndexLayoutProps>(
  function TrustIndexLayout(
    { riskCard, children, circle, circleSlot, videoLoaderMode = false, blurClass = "" },
    listRef,
  ) {
    return (
      <div className="border rounded-lg p-4 md:p-6 flex flex-col gap-2">
        <div className={blurClass}>{riskCard}</div>
        <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-10">
          <div
            ref={listRef}
            className={`flex-1 min-w-0 flex flex-col gap-2 py-2 md:py-6 ${blurClass}`}
          >
            {children}
          </div>
          <div
            className={`flex flex-col items-center justify-center p-2 w-full md:w-[172px] shrink-0 ${
              videoLoaderMode ? "" : "h-auto md:h-[172px]"
            }`}
          >
            {circleSlot ?? (
              <button
                type="button"
                onClick={circle.onClick}
                disabled={!circle.onClick}
                aria-label={circle.ariaLabel}
                className={`relative w-[156px] h-[156px] md:w-full md:h-full flex items-center justify-center rounded-full focus:outline-none ${
                  circle.onClick
                    ? "cursor-pointer active:scale-[0.98] transition-transform"
                    : "cursor-default"
                }`}
              >
                <TrustIndexCircle
                  segments={circle.segments}
                  totalValue={circle.totalValue}
                  totalLabel={circle.totalLabel}
                  title={circle.title}
                  hasTrustScore={circle.hasTrustScore}
                  showSparkle={circle.showSparkle}
                />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  },
);

export default TrustIndexLayout;
